import { ReactElement, useRef } from 'react';
import { useOnClickOutside } from '@/common/service/hooks';
import * as S from './ImagesWidget.styles';
import { Portal } from '@/common/ui/portal';
import { ImagesGallery } from '@/screens/ActivityPage/ui/ActivityDetail/ImagesGallery/ImagesGallery';
import { TImageItem } from '@/common/service/api/Activity/Activity.domain';
import { IVideo } from '@/entities/Activity/domain/Activity.domain';
import { ImageItem } from './ImagesWidget';
import { createYoutubeLink } from '@/common/app/utils/createYoutubeLink';

type TImagesPopup = {
    userImages: TImageItem[];
    videos: IVideo[];
    path: string;
    startPosition?: number;
    showAll?: boolean;
    onClose: () => void;
    showSingleImage: (position?: number) => void;
};

export const ImagesPopup = ({
    userImages,
    videos,
    path,
    startPosition,
    showAll,
    onClose,
    showSingleImage,
}: TImagesPopup): ReactElement => {
    const ref = useRef<HTMLDivElement>(null);
    useOnClickOutside(ref, () => onClose());
    const indexStep = videos.length ? 2 : 1;

    return (
        <Portal>
            <S.Wrapper>
                <S.Modal ref={ref}>
                    <S.Header>
                        <S.SubHeading>{!!showAll && 'All photos'}</S.SubHeading>
                        <S.CloseButton onClick={onClose}>
                            <S.CloseButtonWithIcon />
                        </S.CloseButton>
                    </S.Header>
                    {showAll ? (
                        <S.GridWrap>
                            <S.Grid>
                                {videos.map((video) => {
                                    return (
                                        <S.VideoItem
                                            key={video.link}
                                            onClick={() => showSingleImage()}
                                        >
                                            <iframe src={createYoutubeLink(video.link)} />
                                        </S.VideoItem>
                                    );
                                })}
                                {userImages.map(({ id, slug }, index) => (
                                    <ImageItem
                                        path={path}
                                        id={id}
                                        slug={slug}
                                        restNumber=""
                                        key={id}
                                        onClick={() => showSingleImage(index + indexStep)}
                                    />
                                ))}
                            </S.Grid>
                        </S.GridWrap>
                    ) : (
                        <ImagesGallery
                            userImages={userImages}
                            activitySlug=""
                            activityId=""
                            videos={videos}
                            type="landmark_photo"
                            startPosition={startPosition}
                        />
                    )}
                </S.Modal>
            </S.Wrapper>
        </Portal>
    );
};
